import { render, staticRenderFns } from "./xdslGeneral.vue?vue&type=template&id=f93e0d7c&scoped=true&"
import script from "./xdslGeneral.vue?vue&type=script&lang=js&"
export * from "./xdslGeneral.vue?vue&type=script&lang=js&"
import style0 from "./xdslGeneral.vue?vue&type=style&index=0&id=f93e0d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93e0d7c",
  null
  
)

export default component.exports